import { LEAD_GEN_FORM } from '../../../../fields'

export const getCustomizedAdLeadGenFormPayload = (ad, values) => {
  return {
    asset_feed_spec: {
      call_to_actions: [
        {
          type: ad.creative.asset_feed_spec?.call_to_actions?.[0]?.type,
          value: {
            lead_gen_form_id: values[LEAD_GEN_FORM]
          }
        }
      ]
    }
  }
}

export const getSingleVideoAdLeadGenFormPayload = (ad, values) => {
  return {
    video_data: {
      call_to_action: {
        ...ad.creative.object_story_spec?.video_data?.call_to_action,
        value: {
          [LEAD_GEN_FORM]: values[LEAD_GEN_FORM]
        }
      }
    }
  }
}

export const getSingleImageAdLeadGenFormPayload = (ad, values) => {
  return {
    link_data: {
      call_to_action: {
        ...ad.creative.object_story_spec?.link_data?.call_to_action,
        value: {
          [LEAD_GEN_FORM]: values[LEAD_GEN_FORM]
        }
      }
    }
  }
}
